import React, { useState } from 'react';
import Header from '../components/Header';
import FooterSection from '../components/FooterSection';

const PricingPage: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleSubscribeClick = () => {
    if (isRedirecting) return;

    setShowPopup(true);
    setIsRedirecting(true);

    // تغییر کرسر به حالت لودینگ
    document.body.style.cursor = 'wait';

    setTimeout(() => {
      const { protocol, hostname, port } = window.location;
      const hasChatPrefix = hostname.startsWith('chat.');
      const cleanHost = hasChatPrefix ? hostname : `chat.${hostname}`;
      const redirectURL = `${protocol}//${cleanHost}${port ? `:${port}` : ''}`;
      window.location.href = redirectURL;
    }, 3000);
  };

  const plans = [
    {
      title: 'پایه',
      description: 'برای استفاده محدود و موردی کاربران عادی بدون نیاز به امکانات تخصصی',
      price: '۱۱۶٬۰۰۰ تومان / ماه',
      features: [
        'GPT-4o mini - تقریبا ۲,۳۰۰ پیام',
        'Gemini 1.5 pro - تقریبا ۱۲۰ پیام',
        'OpenAI o1-mini - تقریبا ۱۵۰ پیام',
        'فایل‌ها و پایگاه دانش (PDF / MD / DOC / XLS / PPT)',
        'ذخیره‌سازی فایل: 1.0 GB',
        'ارسال پیام نامحدود',
        'پشتیبانی از تمام ارائه‌دهندگان جهانی',
        'افزونه‌های خاص و اختصاصی',
        'دسترسی به دستیاران حرفه‌ای و قدرتمند',
        'جستجوی پیشرفته در اینترنت',
      ],
      highlight: false,
    },
    {
      title: 'استاندارد',
      description: 'مخصوص کاربرانی که به صورت روزمره از هوش مصنوعی استفاده می‌کنند',
      price: '۲۹۰٬۰۰۰ تومان / ماه',
      features: [
        'GPT-4o mini - تقریبا ۵,۴۹۹ پیام',
        'Gemini 1.5 pro - تقریبا ۳۰۰ پیام',
        'OpenAI o1-mini - تقریبا ۳۶۵ پیام',
        'فایل‌ها و پایگاه دانش (PDF / MD / DOC / XLS / PPT)',
        'ذخیره‌سازی فایل: 2.0 GB',
        'ارسال پیام نامحدود',
        'پشتیبانی از تمام ارائه‌دهندگان جهانی',
        'افزونه‌های خاص و اختصاصی',
        'دسترسی به دستیاران حرفه‌ای و قدرتمند',
        'جستجوی پیشرفته در اینترنت',
      ],
      highlight: false,
    },
    {
      title: 'ویژه',
      description: 'برای کاربرانی که برای کارهای تخصصی از هوش مصنوعی استفاده می‌کنند',
      price: '۵۸۱٬۰۰۰ تومان / ماه',
      features: [
        'GPT-4o mini - تقریبا ۱۱,۷۰۰ پیام',
        'Gemini 1.5 pro - تقریبا ۶۰۰ پیام',
        'OpenAI o1-mini - تقریبا ۷۵۰ پیام',
        'فایل‌ها و پایگاه دانش (PDF / MD / DOC / XLS / PPT)',
        'ذخیره‌سازی فایل: 4.0 GB',
        'ارسال پیام نامحدود',
        'پشتیبانی از تمام ارائه‌دهندگان جهانی',
        'افزونه‌های خاص و اختصاصی',
        'دسترسی به دستیاران حرفه‌ای و قدرتمند',
        'جستجوی پیشرفته در اینترنت',
      ],
      highlight: true,
    },
    {
      title: 'نهایی',
      description: 'برای کاربرانی که نیاز حرفه‌ای و بسیار بالا به AI دارند',
      price: '۹۹۸٬۰۰۰ تومان / ماه',
      features: [
        'GPT-4o mini - تقریبا ۲۳,۴۰۰ پیام',
        'Gemini 1.5 pro - تقریبا ۱,۲۰۰ پیام',
        'OpenAI o1-mini - تقریبا ۱,۵۰۰ پیام',
        'فایل‌ها و پایگاه دانش (PDF / MD / DOC / XLS / PPT)',
        'ذخیره‌سازی فایل: 4.0 GB',
        'ارسال پیام نامحدود',
        'پشتیبانی از تمام ارائه‌دهندگان جهانی',
        'افزونه‌های خاص و اختصاصی',
        'دسترسی به دستیاران حرفه‌ای و قدرتمند',
        'جستجوی پیشرفته در اینترنت',
      ],
      highlight: false,
    },
  ];

  return (
    <div className="min-h-screen bg-black text-white flex flex-col relative">
      <Header selectedTab="" onTabChange={() => {}} />

      <main className="flex-grow px-6 py-24 max-w-screen-xl mx-auto text-right" dir="rtl">
        <h1 className="text-4xl font-extrabold mb-6 text-center">طرح‌های قیمت‌گذاری</h1>
        <p className="text-neutral-400 mb-12 text-center text-lg">
          بسته‌ای را انتخاب کنید که متناسب با نیاز شماست.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {plans.map((plan) => (
            <div
              key={plan.title}
              className={`rounded-xl p-6 border transition-all flex flex-col justify-between ${
                plan.highlight
                  ? 'border-orange-400 shadow-xl bg-gradient-to-bl from-[#00D9A5] via-[#FACC15] to-[#FB923C]'
                  : 'border-zinc-700 bg-zinc-900 text-white'
              }`}
            >
              <div>
                <h2 className={`text-2xl mb-2 ${plan.highlight ? 'text-black font-bold' : 'font-bold'}`}>
                  {plan.title}
                </h2>
                <p className={`text-sm mb-4 ${plan.highlight ? 'text-neutral-800' : 'text-neutral-400'}`}>
                  {plan.description}
                </p>
                <p className={`text-2xl mb-6 ${plan.highlight ? 'text-black font-bold' : 'text-extrabold'}`}>
                  {plan.price}
                </p>
                <ul className={`space-y-2 mb-6 text-sm ${plan.highlight ? 'text-black' : 'text-neutral-300'}`}>
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-green-400">✔</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                onClick={handleSubscribeClick}
                className={`w-full mt-auto py-3 rounded-lg font-bold transition-all ${
                  plan.highlight
                    ? 'bg-black text-white hover:bg-neutral-900'
                    : 'bg-white text-black hover:bg-neutral-200'
                }`}
              >
                عضویت
              </button>
            </div>
          ))}
        </div>
      </main>

      {/* پاپ‌آپ وسط صفحه */}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
          <div className="bg-white text-neutral-600 rounded-xl px-8 py-6 shadow-2xl animate-fade-in w-full max-w-md text-center text-base">
            <p>
              در پروفایل کاربری اقدام به خرید اشتراک کنید
            </p>
          </div>
        </div>
      )}

      <FooterSection />
    </div>
  );
};

export default PricingPage;
